import React from 'react';
import { useTranslation } from 'react-i18next';
import { NS } from '../U3204';

interface U3204ConversationFilterInputProps {
  value: string;
  onChange: (value: string) => void;
}

const U3204ConversationFilterInput: React.FC<U3204ConversationFilterInputProps> = ({ value, onChange }) => {
  const { t } = useTranslation(NS);

  return (
    <div>
      <label htmlFor="u3204-conversation-filter" className="mb-1 block text-xs font-medium text-muted-foreground">
        {t('filterConversations', { ns: NS })}
      </label>
      <input
        id="u3204-conversation-filter"
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t('filterConversationsPlaceholder', { ns: NS })}
        className="w-full rounded-lg border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-primary/40"
      />
    </div>
  );
};

export default U3204ConversationFilterInput;
